function strut_bagBoxInit(){
    //@ts-ignore
    baguetteBox.run('main .imageblock__link, .wp-block-gallery');
}

strut_bagBoxInit();

class StrutBlogWidget{

    private container:HTMLElement
    private activePage:number;
    private numPages:number;


    constructor(containerElem:HTMLElement){
        this.container = containerElem;
        this.activePage = 0;
        this.numPages = 0;
        this.setupBullets = this.setupBullets.bind(this);

        window.addEventListener('resize', () => {
            const numPages = this.getNumPages();
            if(numPages !== this.numPages){ //only run when num visible items changes
                this.setupBullets();
                this.updatePrevNextBtns();
                this.setupRightPadding();
            }
        });
        this.setupBullets();
        this.setupPrevNextBtns();
        this.updatePrevNextBtns();
        this.setupRightPadding();
        this.setupScrollListner();
    }


    // tie in swipe through with navigation bullets
    setupScrollListner(){

        const debounce = (func:Function) => {
            let timer:any;
            return () => {
                clearTimeout(timer);
                timer = setTimeout(() => { func.apply(this, [] ); }, 50);
            };
        }

        const viewport = this.container.querySelector('.blog-list-viewport') as HTMLElement;
        viewport.addEventListener('scroll', debounce(() => {

            const itemWidth = parseInt(window.getComputedStyle(this.container.querySelector('.blog-list-viewport > .blog-item:first-child')).width);
            let gap = parseInt(window.getComputedStyle(viewport).columnGap);
            const itemIdx = Math.ceil(viewport.scrollLeft / (itemWidth + gap));

            const page = Math.floor(itemIdx/this.getNumItemsVisible());
            this.updateActiveBullet(page);

        }));

    }

    // Extra right padding to make last item sit properly to the left and not stuck at the end
    setupRightPadding(){
        const numPages = this.getNumPages();
        const numVisItems = this.getNumItemsVisible();
        const viewport = this.container.querySelector('.blog-list-viewport') as HTMLElement;
        const viewportWidth = parseInt(getComputedStyle(this.container).width);
        const itemWidth = parseInt(window.getComputedStyle(this.container.querySelector('.blog-list-viewport > .blog-item:first-child')).width);
        let rightPadding = viewportWidth - (numVisItems * itemWidth);
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)


        if(numPages < 2 || vw <= 600 || viewportWidth == itemWidth){
            rightPadding = 0;
        }

        viewport.style.paddingRight = `${rightPadding}px`;

    }

    // create bullet navigation
    setupBullets(){
        const numPages = this.getNumPages();
        const bulletLists = this.container.querySelectorAll('ul.bullets');

        if(bulletLists && bulletLists.length > 1){
            bulletLists.forEach((bulletUL:HTMLElement) => {
                if(bulletUL){
                    let newList = '';

                    for(let i = 0; i < numPages; i++){

                        let activeClass = '';
                        if(this.activePage == i){
                            activeClass = 'active'
                        }

                        newList += `<li><button class='${activeClass}' data-page-idx='${i}' aria-title='page ${i+1} of ${numPages}'></button></li>`;
                    }

                    bulletUL.innerHTML = newList;

                    if(numPages > 1){
                        bulletUL.parentElement.style.visibility = 'visible';
                    }else{
                        bulletUL.parentElement.style.visibility = 'hidden';
                    }

                    const btns = bulletUL.querySelectorAll('button');
                    if(btns && btns.length && btns.length > 0){
                        btns.forEach(btn => btn.addEventListener('click', (e) => {
                            const btn = e.currentTarget as HTMLElement;
                            let pageAtr = btn.getAttribute('data-page-idx')
                            if(pageAtr){
                                const newPage = parseInt(pageAtr);
                                this.scrollToPage(newPage)
                            }
                        }))
                    }
                }
            });
        }

        this.numPages = numPages;


        //reset slider
        this.scrollToPage(0);
    }

    //
    scrollToPage(newPage:number){
        const viewport = this.container.querySelector('.blog-list-viewport') as HTMLElement;
        const itemWidth = parseInt(window.getComputedStyle(this.container.querySelector('.blog-list-viewport > .blog-item:first-child')).width);

        let gap = parseInt(window.getComputedStyle(viewport).columnGap);
        gap = Math.max(0, gap);

        const numVisItems = this.getNumItemsVisible();
        const newLeft = ((newPage * numVisItems) * itemWidth) + (gap * newPage);

        viewport.scroll({
            left: newLeft,
            top: 0,
            behavior: 'smooth'
        });


        this.activePage = newPage;
        this.updateActiveBullet(newPage);
        this.updatePrevNextBtns();
    }


    updateActiveBullet(page:number){

        const active = this.container.querySelectorAll('.active');
        if(active && active.length > 0){
            active.forEach((btn:HTMLElement) => {
                btn.classList.remove('active');
            });
        }

        const next = this.container.querySelectorAll(`[data-page-idx="${page}"]`)
        if(next && next.length > 0){
            next.forEach((btn:HTMLElement) => {
                btn.classList.remove('active');
                btn.classList.add('active');
            });
        }
    }

    // setup event litners on next/prev
    setupPrevNextBtns(){
        const prev = this.container.querySelectorAll('.blog-nav-prev');
        const next = this.container.querySelectorAll('.blog-nav-next');

        if(prev && prev.length > 0){
            prev.forEach((btn:HTMLElement) => {
                btn.addEventListener('click', () => {
                    if(this.activePage > 0){
                        this.scrollToPage(this.activePage - 1);
                    }
                });
            });
        }
        if(next && next.length > 0){
            next.forEach((btn:HTMLElement) => {
                btn.addEventListener('click', () => {
                    if(this.activePage + 1 < this.numPages){
                        this.scrollToPage(this.activePage + 1);
                    }
                });
            });
        }
    }

    // enable/disable next/prev depending on navigation
    updatePrevNextBtns(){
        const prev = this.container.querySelectorAll('.blog-nav-prev');
        const next = this.container.querySelectorAll('.blog-nav-next');

        if(this.activePage == 0){
            if(prev && prev.length > 0){
                prev.forEach((btn:HTMLElement) => {
                    btn.setAttribute('disabled', 'disabled');
                });
            }
        }

        if(this.activePage > 0){
            if(prev && prev.length > 0){
                prev.forEach((btn:HTMLElement) => {
                    btn.removeAttribute('disabled');
                });
            }
        }

        if(this.activePage < this.numPages){
            if(next && next.length > 0){
                next.forEach((btn:HTMLElement) => {
                    btn.removeAttribute('disabled');
                });
            }
        }
        if(this.activePage == this.numPages -1){
            if(next && next.length > 0){
                next.forEach((btn:HTMLElement) => {
                    btn.setAttribute('disabled', 'disabled');
                });
            }
        }
    }


    getNumPages():number{
        const numItems = this.container.querySelectorAll('.blog-list-viewport > .blog-item').length;
        const numPages = Math.round(numItems / this.getNumItemsVisible());
        return numPages;
    }

    getNumItemsVisible():number{
        const listWidth = parseInt(window.getComputedStyle(this.container.querySelector('.blog-list')).width);
        const itemWidth = parseInt(window.getComputedStyle(this.container.querySelector('.blog-list-viewport > .blog-item:first-child')).width);


        const itemsVisible = Math.max(1, Math.floor(listWidth/itemWidth));

        return itemsVisible;
    }
}

class StrutFAQWidget{
    private container:HTMLElement;
    constructor(container:HTMLElement){
        this.container = container;
        this.toggleOpen = this.toggleOpen.bind(this);
        this.setup();
    }
    toggleOpen = (btn:HTMLElement, faqAns:HTMLElement) => {
        let isOpen = btn.getAttribute('aria-expanded') == 'true';

        btn.setAttribute('aria-expanded',  isOpen ? 'false' : 'true');
        isOpen = !isOpen;

        let newHeight = isOpen ? faqAns.getAttribute('data-height') : '0px';
        faqAns.style.height = newHeight;
    }

    setup(){
        const btns = this.container.querySelectorAll('dt > button');
        btns.forEach(btn => {
            // keep track of height
            const faqItem = btn.parentElement as HTMLElement
            const faqAnsWrap =  faqItem.nextElementSibling.children[0] as HTMLElement;
            const faqAns =  faqAnsWrap.children[0] as HTMLElement;

            if(faqAns){
                faqAns.setAttribute('data-height', window.getComputedStyle(faqAns).height);
                faqAns.style.height = '0px';
                faqAnsWrap.style.height = 'auto';
            }

            console.log('setting up faq', faqItem);

            faqItem.addEventListener('click', (e) => {
                e.stopPropagation();
                const faqItem = (e.target as HTMLElement);
                const btn = faqItem.querySelector('button') as HTMLElement;
                const faqAnsWrap = faqItem.nextElementSibling.children[0] as HTMLElement;
                const faqAns = faqAnsWrap.children[0] as HTMLElement;
                this.toggleOpen(btn, faqAns);
            });

            btn.addEventListener('click', (e) => {
                const btn = e.currentTarget as HTMLElement;
                const faqItem = btn.parentElement as HTMLElement
                const faqAnsWrap =  faqItem.nextElementSibling.children[0] as HTMLElement;
                const faqAns =  faqAnsWrap.children[0] as HTMLElement;
                this.toggleOpen(btn, faqAns);
            });
        })
    }
}

function strut_init(){
    const blogWidgets = document.querySelectorAll(".blog");
    if(blogWidgets && blogWidgets.length && blogWidgets.length > 0){
        blogWidgets.forEach(containerElem => new StrutBlogWidget(containerElem as HTMLElement));
    }

    //faqs
    const faqWidgets = document.querySelectorAll('dl.strutfaqs');
    if(faqWidgets && faqWidgets.length && faqWidgets.length > 0){
        faqWidgets.forEach(containerElem => new StrutFAQWidget(containerElem as HTMLElement));
    }
}
window.addEventListener('load', function(){
    window.setTimeout(strut_init, 1000)
});
